// Copied from gp/components/FollowerRange/index.tsx but we handle the search callback here

import React, { useEffect, useMemo, useState } from 'react';
import { Dropdown, Bubble, Icon, Input, Button, List, SearchBox } from 'tea-component';
import '@gp/components/FollowerRange/index.scss';
import classnames from 'classnames';
import NoData from '@gp/components/NoData';
import useSearchable from './useSearchable';
import { getTextWithHighlight } from '@intelligence/utils/commonUtils';
import { messageTips } from '@gp/utils/common';
import { getOptionsWithLabel } from '@gp/utils/select';
import { CONSTANT_TEXTS, GET_TEXT_WITH_HIGHLIGHT_OPTION } from '@gp/constants/const';
import './index.scss';

interface PropsType {
  className?: string;
  overlayClassName?: string;
  boxClassName?: string;
  dropdownOverlayBoxClassName?: string;
  value: string;
  options: any[];
  onChange: (value: string) => void;
  onSearch?: (searchTerm: string) => void; // New callback for server-side search
  label?: string;
  button?: string | React.ReactElement | null;
  placeholder?: string;
  placeholderStyle?: React.CSSProperties; // Custom style for placeholder
  customizePlaceholder?: string;
  isCustomize?: boolean;
  clearable?: boolean;
  searchable?: boolean;
  searchPlaceholder?: string;
  onClose?: () => void;
  [keyName: string]: any;
}

export default function FollowerRange(props: PropsType) {
  const {
    className,
    overlayClassName,
    boxClassName,
    dropdownOverlayBoxClassName,
    value,
    options: propsOptions,
    onChange,
    onSearch,
    label,
    button,
    placeholder,
    placeholderStyle,
    customizePlaceholder,
    isCustomize = true,
    clearable = false,
    searchable = false,
    searchPlaceholder = 'Search',
    onClose,
    ...remains
  } = props;

  // 面板类型 select/customized
  const [activePanel, setActivePanel] = useState<string>('select');
  // 动态新增自定义option
  const [options, setOptions] = useState<any[]>(propsOptions);
  const [inputStartError] = useState<boolean>(false);
  const [inputVal, setInputVal] = useState<string>('');
  const inputValTrim = inputVal?.trim() || '';

  const buttonText = useMemo(() => {
    if (button) return button;
    let result = value;
    if (!Array.isArray(options)) return result;
    for (let i = 0, l = options?.length; i < l; i++) {
      const t = options?.[i];
      if (t?.value == value) {
        result = t?.text;
        break;
      }
    }

    return result;
  }, [button, value, options]);

  const { filteredOptions, keywords, onKeywordsChange, clearKeywords } = useSearchable(options, searchable, onSearch);
  const filteredOptionsNoData = !filteredOptions?.length;

  useEffect(() => {
    setOptions(getOptionsWithLabel(propsOptions));
  }, [propsOptions]);

  return (
    <Dropdown
      className={`dbg-followerfilter ${className ? className : ''}`}
      overlayClassName={classnames('dbg-common-overlay', overlayClassName)}
      boxClassName={classnames('dbg-follower-filter-box', boxClassName, {
        'is-customize-panel-sg': activePanel === 'customized',
      })}
      updateOnChildrenChange
      button={
        <div className="dbg-followerfilter-inner">
          {label && <span className="select-button-text">{label}</span>}
          {buttonText ? (
            <span className="dbg-followerfilter-value">{buttonText}</span>
          ) : (
            <span className="tea-text-weak" style={placeholderStyle}>{placeholder}</span>
          )}
        </div>
      }
      size="m"
      appearance="button"
      clickClose={false}
      clearable={!!value && clearable}
      onClose={() => {
        clearKeywords();
        setInputVal('');
        setActivePanel('select');
        onClose?.();
      }}
      {...remains}
    >
      {(close) => (
        <>
          {activePanel === 'select' ? (
            <>
              {searchable && (
                <SearchBox
                  placeholder={searchPlaceholder}
                  value={keywords}
                  onChange={onKeywordsChange}
                  onClear={() => {
                    onKeywordsChange('');
                  }}
                />
              )}
              <div className={classnames('dbg-followerfilter-select-wrap', dropdownOverlayBoxClassName)}>
                {filteredOptionsNoData && (
                  <NoData className="dbg-followerfilter-no-data" text={CONSTANT_TEXTS.EMPTY_TEXT}/>
                )}
                {filteredOptionsNoData || (
                  <List type="option" className="dbg-followerfilter-selectbox">
                    {filteredOptions?.map((item, index) => (
                      <List.Item
                        // className={`${
                        //   value == item.value ? 'is-selected' : ''
                        // }`}
                        className={classnames('dbg-followerfilter-selectbox__item', {
                          disabled: item?.disabled,
                          'is-selected': value === item?.value,
                        })}
                        key={index}
                        // @ts-ignore
                        title={item?.text}
                        onClick={() => {
                          if (item?.disabled) return;
                          onChange(item.value);
                          close();
                        }}
                      >
                        {getTextWithHighlight(item.text, keywords, GET_TEXT_WITH_HIGHLIGHT_OPTION)}
                      </List.Item>
                    ))}
                  </List>
                )}
                {isCustomize && (
                  <div
                    className="dbg-followerfilter-footer"
                    onClick={() => {
                      setActivePanel('customized');
                    }}
                  >
                    Customize
                  </div>
                )}
              </div>
            </>
          ) : (
            <div className={classnames('dbg-followerfilter-input-wrap', dropdownOverlayBoxClassName)}>
              <div className="dbg-followerfilter-input">
                <div className={`dbg-followerfilter-input-item ${inputStartError ? 'error' : ''}`}>
                  <Bubble error content="错误示例" visible={inputStartError}>
                    <Input
                      value={inputVal}
                      onChange={(value) => {
                        setInputVal(value);
                      }}
                      placeholder={customizePlaceholder}
                    />
                    {inputVal && (
                      <Icon
                        type="dismiss"
                        onClick={() => {
                          setInputVal('');
                        }}
                      />
                    )}
                  </Bubble>
                  {/* <div className="dbg-followerfilter-input-unit">K</div> */}
                </div>

                {/* <span className="dbg-followerfilter-input-gap">-</span>
                <div
                  className={`dbg-followerfilter-input-item ${
                    inputEndError ? 'error' : ''
                  }`}
                >
                  <Bubble error content="错误提示示例" visible={inputEndError}>
                    <Input
                      value={endRange}
                      onChange={(value) => {
                        setEndRange(value);
                      }}
                      placeholder=""
                    />
                  </Bubble>
                  <div className="dbg-followerfilter-input-unit">K</div>
                </div> */}
              </div>
              <div className="dbg-followerfilter-btngroup">
                <Button
                  type="primary"
                  disabled={!inputValTrim}
                  onClick={() => {
                    // Check if custom input matches any existing text or text2 (case-insensitive)
                    const inputValTrimLower = inputValTrim.toLowerCase();
                    const optionTarget = options?.find((option) => 
                      option?.text?.trim().toLowerCase() === inputValTrimLower || 
                      option?.text2?.trim().toLowerCase() === inputValTrimLower
                    );
                    if (inputValTrim && optionTarget) {
                      messageTips('error', 'This project name already exists. Please enter a different name.');
                      return;
                    }
                    onChange(inputValTrim);
                    setInputVal('');
                    setActivePanel('select');
                    close();
                  }}
                >
                  Confirm
                </Button>
                <Button
                  type="weak"
                  onClick={() => {
                    setActivePanel('select');
                  }}
                >
                  Back
                </Button>
              </div>
            </div>
          )}
        </>
      )}
    </Dropdown>
  );
}
